import { useContext, createContext } from 'react';

export const CredentialsContext = createContext(null);

export function useCredentialsContext() {
  return useContext(CredentialsContext);
}
